import _ from 'lodash';
import {Table} from 'main/components';
import {useMemo} from 'react';
import {AlertModal} from 'shared/components/modals';
import {Button, EmployeeNameWithAvatar} from 'shared/components';
import CompletedIcon from 'img/list-element-complete@2x.png';
import IncompleteIcon from 'img/list-element-incomplete-default@2x.png';
import {FormattedMessage} from 'react-intl';
import {observer} from 'mobx-react';

function COLUMNS({onShare, onUnshare}) {
  return [
    {
      header: 'performance_reviews.manage.Manager',
      render: (model) => <EmployeeNameWithAvatar employee={model.reviewer} />,
      width: 5,
      sortable: false
    },
    {
      header: 'performance_reviews.view.Submitted',
      render: (model) => <Checkmark checked={model.submitted}/>,
      width: 4,
      className: 'center'
    },
    {
      width: 3,
      render: (model) => <ActionButton model={model} onShare={onShare} onUnshare={onUnshare} />
    }
  ];
}

function Checkmark({checked}) {
  return (
    <div className='flex justify-content-center'>
      <img src={checked ? CompletedIcon : IncompleteIcon} width='18' alt='complete'/>
    </div>
  );
}

function ActionButton({model: review, onShare, onUnshare}) {  
  if (review.hasLink('share')) {
    return (
      <Button onClick={() => onShare(review)} trait='default'>
        <FormattedMessage id='performance_reviews.view.Share' />
      </Button>
    );
  }  
  
  if (review.hasLink('unshare')) {
    return (
      <Button onClick={() => onUnshare(review)} trait='default'>
        <FormattedMessage id='performance_reviews.view.Unshare' />
      </Button>
    );
  }

  return null;
}

export default observer(function ManageSharingModal({isOpen, onClose, reviewee, onShare, onUnshare}) {
  const managerReviews = useMemo(() => {
    return _.filter(reviewee.reviews, (review) => review.isManagerReview)
  }, [reviewee]);
  
  return (
    <AlertModal
      isOpen={isOpen}
      onHide={onClose}
      size='md'
      header='performance_reviews.view.Share'
    >
      <div className='space-y-2'>
        <FormattedMessage
          id='performance_reviews.view.END_REVIEWEE_DESCRIPTION_1'
          values={{revieweeName: _.get(reviewee, 'employee.name')}}
        />
        <Table
          columns={COLUMNS({onShare, onUnshare})}
          searchable={false}
          showLinks={false}
          models={managerReviews}
        />
      </div>
    </AlertModal>
  );
});